import core from "@/helpers/client";
const roleService = {
  async headRoleAsync(applicationId, params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/roles?no-cache=1`,
      params
    );
    return result;
  },
  async getRolesAsync(applicationId, params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/roles?no-cache=1`,
      params
    );
    return result;
  },
  async getRoleAsync(applicationId, id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/roles/${id}?no-cache=1`
    );
    return result;
  },
  
  async getRoleOptionsAsync(applicationId) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/roles/options?no-cache=1`
    );
    return result;
  },
  async createRoleAsync(applicationId, model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/roles`,
      model
    );
    return result;
  },
  async updateRoleAsync(applicationId, id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/roles/${id}`,
      model
    );
    return result;
  },
  async deleteRoleByIdAsync(applicationId, id) {
    const result = await core.delete(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/applications/${applicationId}/roles/${id}`
    );
    return result;
  }
};
export default roleService;
